import { fetchWithAuth, type AccessTokenGetter } from "@/lib/utils";

/** A malformed or unavailable capability endpoint is treated as unsupported. */
export async function supportsSessionParticipation(
  sessionId: string,
  getToken: AccessTokenGetter,
): Promise<boolean> {
  try {
    const response = await fetchWithAuth(
      `/api/sessions/${encodeURIComponent(sessionId)}/capabilities`,
      { cache: "no-store" }, getToken,
    );
    if (!response.ok) return false;
    const payload = await response.json() as { shared_session_pins?: unknown };
    return payload?.shared_session_pins === 1;
  } catch {
    return false;
  }
}

export async function removeSessionFromList(
  sessionId: string,
  getToken: AccessTokenGetter,
): Promise<void> {
  const response = await fetchWithAuth(
    `/api/sessions/${encodeURIComponent(sessionId)}/pin`,
    { method: "DELETE", cache: "no-store" }, getToken,
  );
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
}

export async function addSessionToList(
  sessionId: string,
  getToken: AccessTokenGetter,
): Promise<void> {
  const response = await fetchWithAuth(
    `/api/sessions/${encodeURIComponent(sessionId)}/pin`,
    { method: "PUT", cache: "no-store" }, getToken,
  );
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
}
